import React from 'react';
import Header from 'components/Header';
import { Outlet } from 'react-router-dom';
import './styles/theme.scss'
import SidePane from 'components/SidePane';
import SidepaneContent from 'Modules/Sidepane';
import { ReactComponent as Logo } from 'assets/dfh_logo.svg';
import styles from './App.module.scss'
import useExternalApiService from 'helpers/ExternalApiService';
import { store } from 'stores/Store';

import { init, logEvent, setUserId } from '@amplitude/analytics-browser';

// Coerce to string so TS knows it’s not possibly undefined
const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY!;
//amplitude.getInstance().init(AMPLITUDE_KEY);
console.time("amplitude-init");
init(AMPLITUDE_KEY);
console.timeEnd("amplitude-init");

const App: React.FC = () => {

  const [isSidepaneOpen, setIsSidepaneOpen] = React.useState<boolean>(false)
  const toggleSidePane = () => {
    setIsSidepaneOpen(!isSidepaneOpen)
  }

  /*React.useEffect(() => {
    if (store.user?.userName) {
      console.time("amplitude-init");      
      init(AMPLITUDE_KEY, store.user.userName);
      console.timeEnd("amplitude-init");
      console.log("Logging user name from App.tsx:", store.user?.userName);
      setUserId(store.user.userName);
    }
  }, [store.user?.userName]);*/

  return (
    <SidePane
      togglePane={toggleSidePane}
      isOpen={isSidepaneOpen}
      header='Sales Assistant AI'
      sidepaneContent={<SidepaneContent togglePane={toggleSidePane}/>}>
      <>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
          <Header toggleSidePane={toggleSidePane} isSidepaneOpen={isSidepaneOpen} />
          <Outlet />
        </div>
        <div className={styles.LogoContainer}>
          
        </div>
      </>
    </SidePane>
  );
}


export default App;
